export const formatCPF = (cpf: string | undefined): string => {
  if (!cpf) return '';
  return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
};

export const formatCEP = (cep: string | undefined): string => {
  if (!cep) return '';
  return cep.replace(/^(\d{5})(\d{3})$/, '$1-$2');
};

export const formatCTS = (ctps: string | undefined): string => {
  if (!ctps) return '';
  return ctps.replace(/^(\d{7})(\d{1})$/, '$1-$2');
};

export const formatCNPJ = (cnpj: string | undefined): string => {
  if (!cnpj) return '';
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
};

export const unformatDocs = (cpf: string | undefined): string => {
  if (!cpf) return '';
  return cpf.replace(/\D/g, '');
};

export const isValidCPF = (cpf: string): boolean => {
  // Remove caracteres não numéricos
  cpf = cpf.replace(/\D/g, "");

  // Verifica se tem 11 dígitos ou se todos os números são iguais
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  // Função para calcular um dígito verificador
  const calcularDigito = (cpf: string, fatorInicial: number): number => {
    let soma = 0;
    for (let i = 0; i < cpf.length; i++) {
      soma += parseInt(cpf[i]) * (fatorInicial - i);
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  // Calcula os dois dígitos verificadores
  const primeiroDigito = calcularDigito(cpf.slice(0, 9), 10);
  const segundoDigito = calcularDigito(cpf.slice(0, 10), 11);

  // Retorna true se os dígitos calculados forem iguais aos fornecidos
  return (
    primeiroDigito === parseInt(cpf[9]) && segundoDigito === parseInt(cpf[10])
  );
};

export const isValidCNPJ = (cnpj: string): boolean => {
  // Remove caracteres não numéricos
  cnpj = cnpj.replace(/\D/g, "");

  // Verifica se tem 14 dígitos ou se todos os números são iguais
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

  // Função para calcular um dígito verificador
  const calcularDigito = (cnpj: string, pesos: number[]): number => {
    let soma = 0;
    for (let i = 0; i < pesos.length; i++) {
      soma += parseInt(cnpj[i]) * pesos[i];
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };

  // Pesos para os cálculos dos dígitos verificadores
  const pesosPrimeiroDigito = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesosSegundoDigito = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  // Calcula os dois dígitos verificadores
  const primeiroDigito = calcularDigito(cnpj.slice(0, 12), pesosPrimeiroDigito);
  const segundoDigito = calcularDigito(cnpj.slice(0, 13), pesosSegundoDigito);

  // Retorna true se os dígitos calculados forem iguais aos fornecidos
  return (
    primeiroDigito === parseInt(cnpj[12]) &&
    segundoDigito === parseInt(cnpj[13])
  );
};

export const isValidCPFOrCNPJ = (document: string): boolean => {
  // Remove caracteres não numéricos
  const cleanDocument = document.replace(/\D/g, "");

  // Verifica se é CPF ou CNPJ com base no tamanho
  if (cleanDocument.length === 11) {
    return isValidCPF(cleanDocument); // Chama a validação de CPF
  } else if (cleanDocument.length === 14) {
    return isValidCNPJ(cleanDocument); // Chama a validação de CNPJ
  }

  // Caso não tenha 11 nem 14 dígitos, não é válido
  return false;
};
